import axios from './axiosInstance';

export const servercheck = () => {
  return axios.get('/check/livechk');
};

export const foodsecd = () => {
  return axios.get('/diet/food/se/cd'); // 음식분류코드
};

// 코드 검색
export const getCodeSearch = (grpId) => {
  return axios.get("/diet/code/search", {
    params: { grpId }
  });
};

/* 식품 데이터 기준 데이터 */
export const foodsearch = (params) => {
  return axios.get('/diet/food/search', { params }); // 여러 조건 쿼리스트링으로 전송
};

export const foodsearchcount = (params) => {
  return axios.get('/diet/food/search/count', { params }); // 여러 조건 쿼리스트링으로 전송
};

/* 유저 등록 데이터 */
// 등록데이터 검색(식품정보로 검색)
export const foodcustomsearch = (params) => {
  return axios.get('/diet/food/custom/search', { params }); // 여러 조건 쿼리스트링으로 전송
};

// 등록데이터 갯수 조회
export const foodcustomsearchcount = (params) => {
  return axios.get('/diet/food/custom/search/count', { params }); // 여러 조건 쿼리스트링으로 전송
};

// 등록데이터 검색(user_id로 검색)
export const foodcustominsertlist = () => {
  return axios.get('/diet/food/custom/insert/list');
};

// 유저 음식 등록하는 페이지 호출
export const foodcustominsertview = () => {
  return axios.get('/diet/food/custom/insert/view');
};

// 유저음식 등록
export const foodcustom = (form) => {
  return axios.post('/diet/food/custom/insert', form);
};

// 유저음식 삭제 (숨김 — 과거 식단 기록에는 그대로 남음)
export const foodcustomdelete = (foodCd) => {
  return axios.post('/diet/food/custom/delete', { foodCd });
};

export const dietinsert = () => {
  return axios.get('/diet/hist/calendar');
};

export const getDietHistCalendar = (year, month) => {
  return axios.get('/diet/hist/calendar', { params: { year, month } });
};

export const getDietHistDayInfo = (dietDt) => {
  return axios.get('/diet/hist/day/info', { params: { dietDt } });
};

// 추천 음식 데이터 조회
export const getRecommendFoodList = (foodNm, foodRgSe, foodPos, offset = 0) => {
  return axios.get("/diet/recommend/food/list", {
    params: {
      foodNm: foodNm ?? "",
      foodRgSe: foodRgSe ?? "",
      foodPos: foodPos ?? "",
      offset,
    },
  });
};

// 추천 음식 데이터 총 개수
export const getRecommendFoodListCount = (foodNm, foodRgSe, foodPos) => {
  return axios.get("/diet/recommend/food/list/count", {
    params: {
      foodNm: foodNm ?? "",
      foodRgSe: foodRgSe ?? "",
      foodPos: foodPos ?? "",
    },
  });
};

// 추천 음식 데이터 조회
export const postRecommendFoodList = (foodCd, foodRgSe, foodPos) => {
  return axios.post("/diet/recommend/food/update", {
      foodCd: foodCd,
      foodRgSe: foodRgSe,
      foodPos: foodPos,
  });
};

// 추천 음식 "잘어울림" 목록 조회
export const getRecommendGoodWithList = (foodRcmdSeq) => {
  return axios.get("/diet/recommend/food/goodwith/list", {
    params: { foodRcmdSeq },
  });
};

export const updateRecommendGoodWith = (foodRcmdSeq, goodWith) => {
  return axios.put("/diet/recommend/food/goodwith/update", {
    foodRcmdSeq,
    goodWith, // "foodCd,foodCd,foodCd"
  });
};

// 식단 추천 (userId는 axiosInstance가 자동 추가)
export const getDietRecommend = (regionCd) => {
  return axios.get("/diet/recommend/diet", {
    params: { regionCd: regionCd ?? "KR" },
  });
};

// 식단 추천 v2 — 끼니 목표에 맞춘 상차림 + 추천 섭취량(g). region: ALL/KR/WS/JP/CH/AS/ET
export const getDietRecommendV2 = (dietCd, region) => {
  return axios.get("/diet/recommend/v2", { params: { dietCd, region } });
};

export const deleteRecommendFood = (foodRcmdSeq) => {
  return axios.delete("/diet/recommend/food/update", {
    data: {
      foodRcmdSeq,
    },
  });
};

// 내 식단 등록
export const postHistDayInfo = (dietCd, dietHistSeq, dietHistDtlDtoList, dietDtStr) => {
  return axios.post("/diet/hist/day/info/insert", {
      dietCd: dietCd,
      dietHistSeq: dietHistSeq,
      dietHistDtlDtoList: dietHistDtlDtoList,
      dietDtStr: dietDtStr,
  });
};

// 하루 식단 저장 — 보낸 끼니로 그날을 교체(빠진 끼니·음식은 삭제), 저장된 결과를 돌려받는다
export const postHistDaySave = (dietDt, meals) => {
  return axios.post("/diet/hist/day/save", { dietDt, meals });
};

/* 계정 관련 */
// 회원가입
export const userSignup = (form) => {
  return axios.post('/user/signup', form);
};

// 아이디 중복 체크
export const checkUserid = (userId) => {
  return axios.post('/user/duplicatedloginid', { userId });
};

/*// 전화번호 인증 요청
export const sendPhoneVerification = (phone) => {
  return axios.post(`${API_BASE}/send-verification`, { phone });
};*/

// 로그인
export const userLogin = (userId, passWd) =>
  axios.post('/user/login', { userId, passWd });

// 마이페이지 조회
export const getUserInfo = () =>
  axios.get('/user/myinfo');

// 마이페이지 수정
export const updateUserInfo = (data) =>
  axios.post('/user/update/userinfo', data);
